export default __webpack_public_path__ + "static/media/report.ea152458.svg";